import MessageRequestServices from "@/services/MessageRequestServices";
import MessageRequestRequest from "@/model/requests/MessageRequestRequest";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";

const messageRequestService = new MessageRequestServices();

export const namespaced = true;

export const state = {
  messageRequestSuccess: false,
  acceptLoading: false,
  declineLoading: false,
  acceptSuccess: false,
  declineSuccess: false
};

export const getters = {};

export const mutations = {
  updateMessageRequestSuccess: (state, payload) => {
    state.messageRequestSuccess = payload;
  },
  updateAcceptLoading: (state, payload) => {
    state.acceptLoading = payload;
  },
  updateDeclineLoading: (state, payload) => {
    state.declineLoading = payload;
  },
  updateAcceptSuccess: (state, payload) => {
    state.acceptSuccess = payload;
  },
  updateDeclineSuccess: (state, payload) => {
    state.declineSuccess = payload;
  }
};

export const actions = {
  sendMessageRequest({ commit }, payload = MessageRequestRequest.create) {
    let successAction = () => {
      commit("updateMessageRequestSuccess", true);
    };

    return messageRequestService.createMessageRequest(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  acceptMessageRequest({ commit }, payload = MessageRequestRequest.accept) {
    commit("updateAcceptLoading", true);
    let successAction = () => {
      commit("updateAcceptLoading", false);
      commit("updateAcceptSuccess", true);
    };

    return messageRequestService.acceptMessageRequest(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  declineMessageRequest({ commit }, payload = MessageRequestRequest.decline) {
    commit("updateDeclineLoading", true);
    let successAction = () => {
      commit("updateDeclineLoading", false);
      commit("updateDeclineSuccess", true);
      // commit("updateMessageRequestSuccess", true);
    };

    return messageRequestService.declineMessageRequest(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  }
};
